var EPK = EPK || {};
EPK.PrescriptionStock = EPK.PrescriptionStock || {};

$(function() {
	var args = EPK.PrescriptionStock.ARGS || {};

	// #22146 【開発】処方薬在庫検索 処方薬在庫検索詳細
	if($('#detail-product-info-async').length) {
		// 商品情報取得
		EPK.PrescriptionStock.detailProductInfo();
	}

	// #22146 【開発】処方薬在庫検索 処方薬在庫検索詳細
	if($('#detail-basic-info-async').length) {
		// 基本情報取得
		EPK.PrescriptionStock.detailBasicInfo();
	}

	// #22146 【開発】処方薬在庫検索 処方薬在庫検索詳細
	$('#search-current-space').on('click',function () {
		// 地図情報取得「現在地から探す」押下時
		new EPK.PrescriptionStock.map(args);
	})

	// #22146 【開発】処方薬在庫検索 処方薬在庫検索詳細
	if($("#footer-contents-box-async").length) {
		// フッター店舗情報取得
	    EPK.PrescriptionStock.detailBottomNav();
	}
});

/**
 * #22146 【開発】処方薬在庫検索 処方薬在庫検索詳細 商品情報取得
 * @method detailProductInfo
 */
EPK.PrescriptionStock.detailProductInfo = function () {
	var targetEl = '';
	var productInfo = '';
	var dtTag = '';
	var liTag = '';
	var h2Tag = '';
	var tdTag = '';
	var mN = EPK.PrescriptionStock.mN;

	if (!mN) {
		console.log('/api/prescription_stock/detail/product_info not request params');
		return false;
	}

	$.ajax({
		type: 'post',
		url: '/api/prescription_stock/detail/product_info',
		data: {
			'm_n': mN
		},
		cache: false,
		dataType : 'json',
		timeout: 50000
	}).done(function(data, textStatus, jqXHR) {

		if (!data.result) {
			console.log('/api/prescription_stock/detail/product_info data is empty');
			console.log(data.message);
			return false;
		}

		// 商品画像
		if (data.product_info.img_url) {
			targetEl = $('.medicine-header');
			productInfo = targetEl.find('#imgurl-async');
			dtTag = '<dt id="imgurl-async" class="thumb"> <span class="picture"> <img src="'+data.product_info.img_url+'" alt="'+data.product_info.m_name+'"> </span> </dt>';
			productInfo.after(dtTag);
			productInfo.remove();
		}

		// 0: 先発品 1: 後発品 2：先発品、後発品 両方ある場合
		switch(data.product_info.div_generic) {
			// 先発品
			case 0:
				targetEl = $('.medicine-header');
				productInfo = targetEl.find('#div-generic-async');
				liTag = '<li id="div-generic-async" class="original">先発品</li>';
				productInfo.after(liTag);
				productInfo.remove();
				break;
			// 後発品
			case 1:
				targetEl = $('.medicine-header');
				productInfo = targetEl.find('#div-generic-async');
				liTag = '<li id="div-generic-async" class="generic">後発品</li>';
				productInfo.after(liTag);
				productInfo.remove();
				break;
			// 先発品、後発品 両方ある場合
			case 2:
				targetEl = $('.medicine-header');
				productInfo = targetEl.find('#div-generic-async');
				liTag = '<li id="div-generic-async" class="original">先発品</li><li id="div-generic-async" class="generic">後発品</li>';
				productInfo.after(liTag);
				productInfo.remove();
				break;
		}

		// 商品名
		if (data.product_info.m_name) {
			targetEl = $('.medicine-header');
			productInfo = targetEl.find('#m-name-async');
			h2Tag = '<h2 id="m-name-async">'+data.product_info.m_name+'</h2>';
			productInfo.after(h2Tag);
			productInfo.remove();
		}

		// 一般名
		if (data.product_info.m_ingredient_jp) {
			targetEl = $('.medicine-header');
			productInfo = targetEl.find('#m-ingredient-jp-async');
			tdTag = '<td id="m-ingredient-jp-async">'+data.product_info.m_ingredient_jp+'</td>';
			productInfo.after(tdTag);
			productInfo.remove();
		}

		// 製薬会社
		if (data.product_info.m_comp_name) {
			targetEl = $('.medicine-header');
			productInfo = targetEl.find('#m-comp-name-async');
			tdTag = '<td id="m-comp-name-async">'+data.product_info.m_comp_name+'</td>';
			productInfo.after(tdTag);
			productInfo.remove();
		}

		// 薬価・規格
		if (data.product_info.price_unit_dp_str) {
			targetEl = $('.medicine-header');
			productInfo = targetEl.find('#price-unit-dp-product-unit-async');
			tdTag = '<td id="price-unit-dp-product-unit-async">￥'+data.product_info.price_unit_dp_str+'<small>('+data.product_info.product_unit_name+')</small></td>';
			// 規格がない場合
			if (!data.product_info.product_unit_name) {
				tdTag = '<td id="price-unit-dp-product-unit-async">￥'+data.product_info.price_unit_dp_str+'</td>';
			}
			productInfo.after(tdTag);
			productInfo.remove();
		}

	}).fail( function(data, textStatus, jqXHR) {
		console.log('/api/prescription_stock/detail/product_info failed');
		console.log(data);
		return false;
	});
}

/**
 * #22146 【開発】処方薬在庫検索 処方薬在庫検索詳細 基本情報取得
 * @method detailBasicInfo
 */
EPK.PrescriptionStock.detailBasicInfo = function () {
	var targetEl = '';
	var basicInfo = '';
	var divTag = '';
	var mN = EPK.PrescriptionStock.mN;

	if (!mN) {
		console.log('/api/prescription_stock/detail/basic_info not request params');
		return false;
	}

	$.ajax({
		type: 'post',
		url: '/api/prescription_stock/detail/basic_info',
		data: {
			'm_n': mN
		},
		cache: false,
		dataType : 'json',
		timeout: 50000
	}).done(function(data, textStatus, jqXHR) {

		if (!data.result) {
			console.log('/api/prescription_stock/detail/basic_info data is empty');
			console.log(data.message);
			return false;
		}

		// 作用と効果
		if (data.basic_info.m_operation) {
			targetEl = $('.basic-info');
			basicInfo = targetEl.find('#m-operation-async');
			divTag = '<div id="m-operation-async" class="text"><p>'+data.basic_info.m_operation+'</p></div>';
			basicInfo.after(divTag);
			basicInfo.remove();
		}

		// 使用上の注意
		if (data.basic_info.m_message) {
			targetEl = $('.basic-info');
			basicInfo = targetEl.find('#m-message-async');
			divTag = '<div id="m-message-async" class="text"><p>'+data.basic_info.m_message+'</p></div>';
			basicInfo.after(divTag);
			basicInfo.remove();
		}

		// 用法・用量
		if (data.basic_info.m_handle) {
			targetEl = $('.basic-info');
			basicInfo = targetEl.find('#m-handle-async');
			divTag = '<div id="m-handle-async" class="text"><p>'+data.basic_info.m_handle+'</p></div>';
			basicInfo.after(divTag);
			basicInfo.remove();
		}

		// 副作用
		if (data.basic_info.m_aftereffect) {
			targetEl = $('.basic-info');
			basicInfo = targetEl.find('#m-aftereffect-async');
			divTag = '<div id="m-aftereffect-async" class="text"><p>'+data.basic_info.m_aftereffect+'</p></div>';
			basicInfo.after(divTag);
			basicInfo.remove();
		}

		// 保管方法
		if (data.basic_info.m_comment) {
			targetEl = $('.basic-info');
			basicInfo = targetEl.find('#m-comment-async');
			divTag = '<div id="m-comment-async" class="text"><p>'+data.basic_info.m_comment+'</p></div>';
			basicInfo.after(divTag);
			basicInfo.remove();
		}

	}).fail( function(data, textStatus, jqXHR) {
		console.log('/api/prescription_stock/detail/basic_info failed');
		console.log(data);
		return false;
	});
}

/**
 * #22146 【開発】処方薬在庫検索 処方薬在庫検索詳細 現在地検索 * 
 * @method map
 * @return void
 */
EPK.PrescriptionStock.map = function (args) {
	var _this = this;
	_this.args = args;

	var showError=true;
	var errorInfo = [
		"原因不明のエラーが発生しました。\n圏外でない場合は、端末の位置情報サービスの設定が有効になっているかご確認ください。",
		"位置情報が正しく計測されませんでした。\n圏外でない場合は、端末の位置情報サービスの設定が有効になっているかご確認ください。",
		"電波状況などで位置情報が取得できませんでした。電波状況のいいところで再度お試しください。",
		"位置情報の取得に時間がかかり過ぎてタイムアウトしました。電波状況のいいところで再度お試しください。"
	];

	var errorHandler = function(error) {
		// エラーコード(error.code)の番号
		// 0:UNKNOWN_ERROR				原因不明のエラー
		// 1:PERMISSION_DENIED			利用者が位置情報の取得を許可しなかった
		// 2:POSITION_UNAVAILABLE		電波状況などで位置情報が取得できなかった
		// 3:TIMEOUT					位置情報の取得に時間がかかり過ぎた…

		// エラー番号
		var errorNo = error.code;
		var inOneMinutes = new Date(new Date().getTime() + 1 * 60 * 1000);
		Cookies.set('errorNo', errorNo, { expires: inOneMinutes} );

		if(!showError){
			console.log('現在位置が取得できませんでした。');
			console.log(errorInfo[errorNo]);
			console.log('errorNo:' + errorNo);
			return;
		}

		$('.loading-wrapper').hide();
		$.magnificPopup.close();
		$.magnificPopup.open({
			items: {
				src: '#UnknownLocation',
				type: 'inline'
			}
		});
	};

	var getCurrentPlace = function(){

		// ユーザーの端末がGeoLocation APIに対応しているかの判定
		// 対応している場合
		if (navigator.geolocation) {
			// 現在地を取得
			navigator.geolocation.getCurrentPosition(
				// [第1引数] 取得に成功した場合の関数
				function(position){
					var data = position.coords ;
					var lat = data.latitude;
					var lng = data.longitude;

					EPK.common.latlng.lat = lat;
					EPK.common.latlng.lng = lng;

					_this.mapInitialize()
				},
				// [第2引数] 取得に失敗した場合の関数
				errorHandler.bind(this),

				// [第3引数] オプション
				{
					"enableHighAccuracy": false,
					"timeout": 8000,
					"maximumAge": 2000,
				}
			);
		} // 対応していない場合
		else {
			// エラーメッセージ
			var errorMessage = "現在地情報を取得できませんでした。<br>端末の設定より現在地情報サービスをオンにして下さい。";

			// アラート表示
			alert(errorMessage);
		}
	};

	getCurrentPlace();

};

/**
 * #22146 【開発】処方薬在庫検索 処方薬在庫検索詳細 地図描画初期処理
 * @method mapInitialize
 * @return void
 */
EPK.PrescriptionStock.map.prototype.mapInitialize = function() {
	var _this = this;
	_this.args.param = {"latitude":EPK.common.latlng.lat, "longitude":EPK.common.latlng.lng};
	_this.shopPosition;
	_this.args.map = {};
	_this.args.map.marker = {};
	_this.args.map.markerPin = {};
	_this.args.map.pinIcon = {
		unknown:'/mobile/img/medical_product_inventory/unknown.png',
		ready:'/mobile/img/medical_product_inventory/ready.png',
		partially_ready:'/mobile/img/medical_product_inventory/partially_ready.png',
		not_ready:'/mobile/img/medical_product_inventory/not_ready.png',
		medicinehistory:'/mobile/img/medical_product_inventory/medicinehistory.png',
	};
	_this.args.map.activePinIcon = {
		unknown:'/mobile/img/medical_product_inventory/unknown_active.png',
		ready:'/mobile/img/medical_product_inventory/ready_active.png',
		partially_ready:'/mobile/img/medical_product_inventory/partially_ready_active.png',
		not_ready:'/mobile/img/medical_product_inventory/not_ready_active.png',
		medicinehistory:'/mobile/img/medical_product_inventory/medicinehistory_active.png',
	};

	//値をセット
	if (_this.args.param.zip_code) {
		$('#zipCode').val(this.args.param.zip_code);
		$('#searchBtn').prop('disabled','');
	}

	_this.mapRender();
	_this.mapEvent();

};

/**
 * #22146 【開発】処方薬在庫検索 処方薬在庫検索詳細 マップ描画
 * @method mapRender
 */
EPK.PrescriptionStock.map.prototype.mapRender = function() {

	this.args.param.zoom_level ? this.args.param.zoom_level : this.args.param.zoom_level = 13; //デフォルト

	var initLatLon = new google.maps.LatLng(this.args.param.latitude, this.args.param.longitude);
	this.mapOptions = {
		zoom: Number(this.args.param.zoom_level),
		center: initLatLon,
		mapTypeId: google.maps.MapTypeId.ROADMAP,
		zIndex: 2,
		panControl: false,
		zoomControl: false,
		scaleControl: false,
		streetViewControl: false,
		mapTypeControl: false,
		gestureHandling: 'greedy',
		fullscreenControl: false,
		mapId:"DEMO_MAP_ID",
	};

	this.args.map.initmap = new google.maps.Map(document.getElementById("prescription_stock_canvas"), this.mapOptions);
	this.getShop();
};

/**
 * #22146 【開発】処方薬在庫検索 処方薬在庫検索詳細 店舗情報取得
 * @method getShop
 * @return void
 */
EPK.PrescriptionStock.map.prototype.getShop = function() {
	var _this = this;
	var zoom;
	var data = {
		'latitude': EPK.common.latlng.lat,
		'longitude': EPK.common.latlng.lng,
		'zoom_level': _this.args.param.zoom_level,
		'm_n': EPK.PrescriptionStock.mN,
	};

	//ズームレベルの更新
	zoom = this.args.map.initmap.getZoom();
	if (zoom) data.zoom_level =  zoom;

	$.ajax({
		url: '/api/prescription_stock/detail/get_map',	
		type: 'POST',
		cache: false,
		data: data,
		dataType : 'json',
	}).done(function(data, textStatus, jqXHR){
		if (!data.result) {
			_this.resetShops(true);
		    $('.loading-wrapper').hide();
		    $.magnificPopup.close();
		    $.magnificPopup.open({
			    items: {
				    src: '#noShop',
				    type: 'inline'
			    }
		    });
			console.log('/api/prescription_stock/detail/get_map failed');
			console.log(data.message);
			
			return false;
		}

		_this.resetShops(true);
		if (Object.keys(data.shops).length) {
			_this.renderMarker(data.shops);
		} else {
			$('.loading-wrapper').hide();
			$.magnificPopup.close();
			$.magnificPopup.open({
				items: {
					src: '#noShop',
					type: 'inline'
				}
			});
		}

	}).fail( function(data, textStatus, jqXHR) {
		_this.resetShops(true);
		$('.loading-wrapper').hide();
		$.magnificPopup.close();
		$.magnificPopup.open({
			items: {
				src: '#noShop',
				type: 'inline'
			}
		});
		console.log('/api/prescription_stock/detail/get_map failed');
		console.log(data);
		return false;
	});
};

/**
 * #22146 【開発】処方薬在庫検索 処方薬在庫検索詳細 店舗情報描画
 * @method renderMarker
 * @return void
 */
EPK.PrescriptionStock.map.prototype.renderMarker = function(shopsInfo) {
	var _this = this;
	var weekArry = [ "(日)", "(月)", "(火)", "(水)", "(木)", "(金)", "(土)" ];
	var day,week,getWeek,receiptDate;
	var shopArry = [];
	$.each(shopsInfo,function (key,val) {
		shopArry.push(val);
	})
	for (var i = 0; i < shopArry.length; ++i) {
		var id = shopArry[i].shop_id;
		_this.args.map.markerPin[id] = {};
		var center,icon,scaledSize,anchor;
		//店舗描画
		var slider = $('#sliderPanel');
		var html = slider.render(shopArry[i]);
		if (_this.args.map.swiper) {
			_this.args.map.swiper.appendSlide(html);
		} else {
			$('.map-footer-body').append(html);
		}

		//描画位置を取得
		if (i == 0) {
			_this.shopPosition = $('#'+id).offset();
		}

		//準備可能の時は受け取り可能に変更
		if (shopArry[i].prescription_drug_ready == 1) {
			if (shopArry[i].ready_reception_date && shopArry[i].ready_reception_date.length) {
				receiptDate = [];
				day = new Date(shopArry[i].ready_reception_date);
				week = day.getDay();
				getWeek = weekArry[week];
				receiptDate = shopArry[i].ready_reception_date.split('/');
				receiptDate = receiptDate[1] + '/' + receiptDate[2];
				$('#'+shopArry[i].shop_id+' .flag').empty();
				var receiveFlag = '<span class="day">' + receiptDate + getWeek + '</span>迄に受取り可能';
				$('#'+shopArry[i].shop_id+' .flag').append(receiveFlag);
			}
		}

		//営業時間
		if (shopArry[i].today_time) {
			$('#'+shopArry[i].shop_id+' .salestime').empty();
			$('#'+shopArry[i].shop_id+' .salestime').append(shopArry[i].today_time);
		}

		center = {
			lat:Number(shopArry[i].latitude),
			lng:Number(shopArry[i].longitude),
		}

		if (i == 0) {
			//0はアクティブに変更する
			scaledSize = new google.maps.Size(42, 52);
			anchor = new google.maps.Point(20, 52);
			switch (shopArry[i].prescription_drug_ready) {
				case 0:
					icon = _this.args.map.activePinIcon.not_ready;
					_this.args.map.markerPin[id].notActive = _this.args.map.pinIcon.not_ready;
					break;
				case 1:
					icon = _this.args.map.activePinIcon.ready;
					_this.args.map.markerPin[id].notActive = _this.args.map.pinIcon.ready;
					break;
				case 2:
					icon = _this.args.map.activePinIcon.partially_ready;
					_this.args.map.markerPin[id].notActive = _this.args.map.pinIcon.partially_ready;
					break;
				case 4:
					icon = _this.args.map.activePinIcon.unknown;
					_this.args.map.markerPin[id].notActive = _this.args.map.pinIcon.unknown;
					break;
				case 5:
					icon = _this.args.map.activePinIcon.medicinehistory;
					_this.args.map.markerPin[id].notActive = _this.args.map.pinIcon.medicinehistory;
					break;
				case 6:
					icon = _this.args.map.activePinIcon.unknown;
					_this.args.map.markerPin[id].notActive = _this.args.map.pinIcon.unknown;
					break;
			}
		} else {
			scaledSize = new google.maps.Size(35, 45);
			anchor = new google.maps.Point(16, 45);
			switch (shopArry[i].prescription_drug_ready) {
				case 0:
					icon = _this.args.map.pinIcon.not_ready;
					break;
				case 1:
					icon = _this.args.map.pinIcon.ready;
					break;
				case 2:
					icon = _this.args.map.pinIcon.partially_ready;
					break;
				case 4:
					icon = _this.args.map.pinIcon.unknown;
					break;
				case 5:
					icon = _this.args.map.pinIcon.medicinehistory;
					break;
				case 6:
					icon = _this.args.map.pinIcon.unknown;
					break;
			}
			_this.args.map.markerPin[id].notActive = icon;
		}

		var pinEl = document.createElement("img");
		pinEl.src = icon;
		pinEl.width = scaledSize.width;
		pinEl.height = scaledSize.height;

		_this.args.map.marker[id] = new google.maps.marker.AdvancedMarkerElement({ // マーカーの追加
			title: String(shopArry[i].shop_id),
			position: center, // マーカーを立てる位置を指定
			map: _this.args.map.initmap, // マーカーを立てる地図を指定
			content: pinEl,
		});

		if (i == 0) {
			//0はアクティブに変更する
			_this.args.map.marker[id].zIndex = 2;
		}

		switch (shopArry[i].prescription_drug_ready) {
			case 0:
				_this.args.map.markerPin[id].isActive = _this.args.map.activePinIcon.not_ready;
				break;
			case 1:
				_this.args.map.markerPin[id].isActive = _this.args.map.activePinIcon.ready;
				break;
			case 2:
				_this.args.map.markerPin[id].isActive = _this.args.map.activePinIcon.partially_ready;
				break;
			case 4:
				_this.args.map.markerPin[id].isActive = _this.args.map.activePinIcon.unknown;
				break;
			case 5:
				_this.args.map.markerPin[id].isActive = _this.args.map.activePinIcon.medicinehistory;
				break;
			case 6:
				_this.args.map.markerPin[id].isActive = _this.args.map.activePinIcon.unknown;
				break;
		};
	}

	////ピンクリック
	if (Object.keys(_this.args.map.marker).length) {
		Object.keys(_this.args.map.marker).forEach(function (key,i) {
			_this.args.map.marker[key].addListener('click' ,function () {
				var latitude,longitude;
				var iconData = {
					url : _this.args.map.markerPin[key].notActive,
					scaledSize: new google.maps.Size(35, 45),
					anchor: new google.maps.Point(16, 45),
				};
				//マーカーを非アクティブ化
				Object.keys(_this.args.map.marker).forEach(function (keys) {
					iconData.url = _this.args.map.markerPin[keys].notActive;
					_this.args.map.marker[keys].zIndex = 1;
					_this.args.map.marker[keys].content.src = iconData.url;
					_this.args.map.marker[keys].content.width = iconData.scaledSize.width
					_this.args.map.marker[keys].content.height = iconData.scaledSize.height
				});

				iconData.url = _this.args.map.markerPin[key].isActive;
				iconData.scaledSize = new google.maps.Size(42, 52);
				iconData.anchor = new google.maps.Point(20, 52),

				_this.args.map.marker[key].zIndex = 2;
				_this.args.map.marker[key].content.src = iconData.url;
				_this.args.map.marker[key].content.width = iconData.scaledSize.width
				_this.args.map.marker[key].content.height = iconData.scaledSize.height

				//パン
				latitude = _this.args.map.marker[key].position.lat;
				longitude = _this.args.map.marker[key].position.lng;
				_this.args.map.initmap.panTo(new google.maps.LatLng(latitude,longitude));

				var slideEls = $('.map-footer-body .mapshop');
				if (slideEls.length) {
					for (var i = 0; i < slideEls.length; i++) {
						if ($(slideEls[i]).attr('id') == key) {
							//スライダー移動
							_this.args.map.swiper.slideTo(i, 300, false);
						}
					}
				}
			});
		})
	}

	if (!_this.args.map.swiper) {
		_this.args.map.swiper = $('#medicine_search').swiper({
			slidesPerView:'auto',
			loop:false,
			mousewheel: true, // マウスホイールでスライド
			direction: "vertical", // 縦方向
		});
	}

	_this.args.map.swiper.on('onTransitionEnd', function () {
		_this.selectMarker();
	});
	$('.loading-wrapper').hide();
};

/**
 * #22146 【開発】処方薬在庫検索 処方薬在庫検索詳細 地図描画情報取得
 * @method selectMarker
 * @params obj
 */
EPK.PrescriptionStock.map.prototype.selectMarker = function () {
	var _this = this;
	var activeShop = $('.mapshop.swiper-slide-active');
	var id = activeShop.attr('id');
	var latitude,longitude;

	if(id){
		var iconData = {
			url : _this.args.map.markerPin[id].notActive,
			scaledSize: new google.maps.Size(35, 45),
			anchor: new google.maps.Point(16, 45),
		};
		//マーカーを非アクティブ化
		Object.keys(_this.args.map.marker).forEach(function (keys) {
			iconData.url = _this.args.map.markerPin[keys].notActive;
			_this.args.map.marker[keys].zIndex = 1;
			_this.args.map.marker[keys].content.src = iconData.url;
			_this.args.map.marker[keys].content.width = iconData.scaledSize.width
			_this.args.map.marker[keys].content.height = iconData.scaledSize.height
		});
		iconData.url = _this.args.map.markerPin[id].isActive;
		iconData.scaledSize = new google.maps.Size(42, 52);
		iconData.anchor = new google.maps.Point(20, 52),
		_this.args.map.marker[id].zIndex = 2;
		_this.args.map.marker[id].content.src = iconData.url;
		_this.args.map.marker[id].content.width = iconData.scaledSize.width
		_this.args.map.marker[id].content.height = iconData.scaledSize.height
		latitude = _this.args.map.marker[id].position.lat;
		longitude = _this.args.map.marker[id].position.lng;
		_this.args.map.initmap.panTo(new google.maps.LatLng(latitude,longitude));
	}
};

/**
 * #22146 【開発】処方薬在庫検索 処方薬在庫検索詳細 現在地検索
 * @method currentLocationSearch
 * @return void
 */
 EPK.PrescriptionStock.map.prototype.currentLocationSearch = function () {
	var _this = this;
	var showError=true;
	var errorInfo = [
		"原因不明のエラーが発生しました。\n圏外でない場合は、端末の位置情報サービスの設定が有効になっているかご確認ください。",
		"位置情報が正しく計測されませんでした。\n圏外でない場合は、端末の位置情報サービスの設定が有効になっているかご確認ください。",
		"電波状況などで位置情報が取得できませんでした。電波状況のいいところで再度お試しください。",
		"位置情報の取得に時間がかかり過ぎてタイムアウトしました。電波状況のいいところで再度お試しください。"
	];

	var errorHandler = function(error) {
		// エラーコード(error.code)の番号
		// 0:UNKNOWN_ERROR				原因不明のエラー
		// 1:PERMISSION_DENIED			利用者が位置情報の取得を許可しなかった
		// 2:POSITION_UNAVAILABLE		電波状況などで位置情報が取得できなかった
		// 3:TIMEOUT					位置情報の取得に時間がかかり過ぎた…

		// エラー番号
		var errorNo = error.code;
		var inOneMinutes = new Date(new Date().getTime() + 1 * 60 * 1000);
		Cookies.set('errorNo', errorNo, { expires: inOneMinutes} );

		if(!showError){
			console.log('現在位置が取得できませんでした。');
			console.log(errorInfo[errorNo]);
			console.log('errorNo:' + errorNo);
			return;
		}

		$('.loading-wrapper').hide();
		$.magnificPopup.close();
		$.magnificPopup.open({
			items: {
				src: '#UnknownLocation',
				type: 'inline'
			}
		});
	};

	var shopsInit =  function (position){

		EPK.common.latlng.lat = position.coords.latitude;
		EPK.common.latlng.lng = position.coords.longitude;

		_this.args.map.initmap.panTo(new google.maps.LatLng(EPK.common.latlng.lat, EPK.common.latlng.lng));
	};

	var getCurrentPlace = function(callback, argShowError, argUseCookie){

		// エラー表示の切り替え
		// グローバル変数: showError に情報隔離
		if(argShowError != null){
			showError = argShowError;
		}

		if(typeof argUseCookie == "undefined") {
			argUseCookie = true
		}

		if(argUseCookie){
			var tmpLat = Cookies.get('lat');
			var tmpLng = Cookies.get('lng');
			var tmpErrNo = Cookies.get('errorNo');
			if(tmpLat && tmpLng) {
				EPK.common.latlng.lat = tmpLat*1.0;
				EPK.common.latlng.lng = tmpLng*1.0;
				callback({coords: {latitude: tmpLat, longitude: tmpLng}});
				return;
			}
			if(tmpErrNo){
				EPK.currentPlace.errorNo = tmpErrNo;
			}
		}

		// ユーザーの端末がGeoLocation APIに対応しているかの判定
		// 対応している場合
		if (navigator.geolocation) {
			// 現在地を取得
			navigator.geolocation.getCurrentPosition(
				// [第1引数] 取得に成功した場合の関数
				function(position){
					var data = position.coords ;
					var lat = data.latitude;
					var lng = data.longitude;

					EPK.common.latlng.lat = lat;
					EPK.common.latlng.lng = lng;

					callback(position);
				},
				// [第2引数] 取得に失敗した場合の関数
				errorHandler.bind(this),

				// [第3引数] オプション
				{
					"enableHighAccuracy": false,
					"timeout": 8000,
					"maximumAge": 2000,
				}
			);
		} // 対応していない場合
		else if(showError) {
			// エラーメッセージ
			var errorMessage = "現在地情報を取得できませんでした。<br>端末の設定より現在地情報サービスをオンにして下さい。";

			// アラート表示
			alert(errorMessage);
		}
	};

	getCurrentPlace(shopsInit, true, false);
};


/**
 * #22146 【開発】処方薬在庫検索 処方薬在庫検索詳細 店舗情報初期化
 * @method resetShops
 * @params boolean
 */
EPK.PrescriptionStock.map.prototype.resetShops = function (flag) {
	var _this = this;
	$('.loading-wrapper').show();
	//マーカーのクリア
	if (Object.keys(_this.args.map.marker).length) {
		Object.keys(_this.args.map.marker).forEach(function (key) {
			_this.args.map.marker[key].setMap(null);
		});
		_this.args.map.marker = {};
	}
	//スライダーの削除
	$('.map-footer-body').empty();
	if (!flag) {
		_this.getShop();
	}
};

/**
 * #22146 【開発】処方薬在庫検索 処方薬在庫検索詳細 地図関連のイベント処理設定
 * @method mapEvent
 * @return void
 */
EPK.PrescriptionStock.map.prototype.mapEvent = function() {
	var _this = this;
	var zipCode = $('#zipCode');
	var zipCodeVal;
	var searchBtn = $('#searchBtn');
	var locationBtn = $('.location-btn');
	var research = $('.research');
	var openModal = function (txt) {
		if (txt) {
			$('#zipCodeError div.txt').html(txt);
		}
		$.magnificPopup.close();
		$.magnificPopup.open({
			items: {
				src: '#zipCodeError',
				type: 'inline'
			}
		});
		$('.loading-wrapper').hide();
	}

	//郵便番号　検索
	zipCode.keyup(function () {
		zipCodeVal = $(this).val();
		if (zipCodeVal) {
			searchBtn.prop('disabled','');
		} else {
			searchBtn.prop('disabled','disabled');
		}
	});

    //郵便番号　検索ボタン押下時
	searchBtn.on('click',function () {
		if (zipCodeVal) {

			var zip_code = zipCodeVal.trim();

			if(!$.isNumeric(zip_code)){
				openModal('・郵便番号は半角数値で入力してください。');
				return false;
			}

			if(zip_code.length != 7){
				openModal('・郵便番号は7桁で入力してください。');
				return;
			}
			$('.loading-wrapper').show();
			$.ajax({
				type: 'get',
				url: '/member/get_address_from_zip_code.json',
				data: {'zip_code': zip_code},
				cache: false,
			}).done(function(data){
				if (data.zipcode_data && data.zipcode_data.lat && data.zipcode_data.lon) {
					EPK.common.latlng.lat = data.zipcode_data.lat;
					EPK.common.latlng.lng = data.zipcode_data.lon;
					_this.args.map.initmap.panTo(new google.maps.LatLng(data.zipcode_data.lat,data.zipcode_data.lon));
					_this.resetShops();
				} else {
					$('.loading-wrapper').hide();
					$.magnificPopup.close();
					$.magnificPopup.open({
						items: {
							src: '#noShop',
							type: 'inline'
						}
					});
				}
			}).fail(function(data){
				$('.loading-wrapper').hide();
				$.magnificPopup.close();
				$.magnificPopup.open({
					items: {
						src: '#noShop',
						type: 'inline'
					}
				});
			});
		}
	});

	//ドラッグ開始　スライダー、ピンのクリア
	google.maps.event.addListener(this.args.map.initmap, 'dragstart', function () {
		research.css('display','block');
	});

	//ドラッグ終了
	google.maps.event.addListener(this.args.map.initmap, 'dragend', function () {
		var center = _this.args.map.initmap.getCenter();
		EPK.common.latlng.lat = center.lat();
		EPK.common.latlng.lng = center.lng();
	});

	//ZOOMした時の処理
	google.maps.event.addListener(this.args.map.initmap, 'zoom_changed', function () {
		var center = _this.args.map.initmap.getCenter();
		EPK.common.latlng.lat = center.lat();
		EPK.common.latlng.lng = center.lng();
		zoom = _this.args.map.initmap.getZoom();
		if (zoom) _this.args.param.zoom_level =  zoom;
		research.css('display','block');
	});

	//現在地検索
	locationBtn.css('display','block');
	locationBtn.on('click',function () {
		_this.currentLocationSearch();
		research.css('display','block');
	});

	//このエリアで再検索
	research.on('click',function () {
		research.css('display','none');
		_this.resetShops();
	});
};



/**
 * #22146 【開発】処方薬在庫検索 処方薬在庫検索詳細 フッターナビ情報取得
 * @method detailBottomNav
 */
EPK.PrescriptionStock.detailBottomNav = function () {
	var objSection = $("#footer-contents-box-async");

	$.ajax({
		type: 'post',
		url: '/api/prescription_stock/detail/detail_bottom_nav',
		cache: false,
		dataType : 'html',
		timeout: 50000
	}).done(function(data, textStatus, jqXHR) {
		if (data) {
			objSection.empty();
			objSection.append(data);
			objSection.css('display','');
		} else {
			console.log('data is empty');
		}
	}).fail( function(data, textStatus, jqXHR) {
		console.log('/api/prescription_stock/detail/detail_bottom_nav failed');
		console.log(data);
		return false;
	});
}
